import React from 'react'
import { useDispatch } from 'react-redux'
import saveIcon from '../../assets/social/saveAll.svg'
import saveFilledIcon from '../../assets/social/saveFilled.svg'
import saveFilledWhiteIcon from '../../assets/social/saveFilledWhite.svg'
import {
  DeleteSavedItems,
  SaveItem
} from '../../redux/actions/SaveProductAction'
import { logEvent } from '../../utils/firebase'
import * as styles from './details.module.css'

export const SaveAllProductsBtn = ({
  allIds,
  savedProductIds,
  allSavedProducts
}) => {
  const dispatch = useDispatch()
  //check if all products on the deisgn page is checked/saved
  //if anything remaining, not all products saved
  let allSavedProductsCheck = allIds.filter(productId => {
    if (
      savedProductIds &&
      savedProductIds.length > 0 &&
      savedProductIds.includes(productId)
    ) {
      return ''
    }
    return productId
  })
  const save = e => {
    e.stopPropagation()

    //only saved items not saved yet
    if (allSavedProductsCheck.length > 0) {
      const tag = 'design_productsaveall_clicked'

      logEvent(tag)

      dispatch(SaveItem(allSavedProductsCheck))
    } else {
      //delete all items by ObjectId, not product id.
      //thats why we need to do lookup to get saved object id
      let objectToDelete = []

      allIds.forEach(item => {
        if (allSavedProducts[item] !== undefined)
          objectToDelete.push(allSavedProducts[item])
      })

      const tag = 'design_productunsaveall_clicked'

      logEvent(tag)

      dispatch(DeleteSavedItems(objectToDelete, allIds))
    }
  }

  const isSaved = allSavedProductsCheck.length > 0

  return (
    <div
      className={allIds.length === 0 ? styles.hideSaveAll : styles.showSaveAll}
    >
      <div
        onClick={save}
        id="showall"
        className={`${styles.saveAll} ${
          allSavedProductsCheck.length === 0 ? styles.active : null
        }`}
      >
        <img
          src={isSaved ? saveIcon : saveFilledWhiteIcon}
          alt=""
          className={styles.save}
        />
        <img className={styles.hoverIcon} src={saveFilledIcon} alt="" />
        <span>{isSaved ? 'Save All' : 'Unsave'}</span>
      </div>
    </div>
  )
}
